export const getItemSuffix = (suffix?: string | number) =>
  suffix ? `_${suffix}` : ''
